"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Speisekarte_1 = require("./Speisekarte");
var Slider_1 = require("./Slider");
var Events_1 = require("./Events");
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home(props) {
        var _this = _super.call(this, props) || this;
        _this.karte = React.createRef();
        _this.handleLoad = function () {
            window.localStorage.removeItem('storeScrollTop');
            if (_this.state.karte)
                setTimeout(function () {
                    window.scrollTo(0, _this.karte.current.offsetTop);
                }, 1000);
        };
        _this.state = { karte: props.match.params.hasOwnProperty('item') };
        return _this;
    }
    Home.prototype.componentDidMount = function () {
        window.addEventListener('load', this.handleLoad);
    };
    Home.prototype.componentWillUnmount = function () {
        window.removeEventListener('load', this.handleLoad);
    };
    Home.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(Slider_1.default, { isAdmin: false, folderName: "", fileName: "", deletedEvent: function () { } }),
            React.createElement("div", { ref: this.karte },
                React.createElement(Speisekarte_1.default, { isAdmin: false })),
            React.createElement(Events_1.default, { isAdmin: false })));
    };
    return Home;
}(React.Component));
exports.default = Home;
//# sourceMappingURL=Home.js.map